import { render, staticRenderFns } from "./CdbCustomerList.vue?vue&type=template&id=872bc79c&scoped=true&"
import script from "./CdbCustomerList.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerList.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerList.vue?vue&type=style&index=0&id=872bc79c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872bc79c",
  null
  
)

export default component.exports